export const NUMBER_OF_CHARS_LIMIT_TO_SHOW_TOOLTIP = 7;